import React from 'react';
import { GettyImagesInterface } from '../../types';
import { Popover, Typography } from '@material-ui/core';

interface GettyImagePreviewProps {
  image: GettyImagesInterface;
  anchorEl;
}

export const GettyImagePreview: React.FC<GettyImagePreviewProps> = ({
    anchorEl,
    image
}): React.ReactElement => {
    return (
        <Popover
            style={{ pointerEvents: 'none', maxWidth: 600 }}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
        >
            <div>
                <img alt="getty preview" src={image.display_sizes[0]['uri']} />
            </div>
            <Typography variant={'h6'}>{image.title}</Typography>
            <Typography variant={'subtitle1'}>{image.caption}</Typography>
        </Popover>
    );
};
